__turbopack_context__.v({
  "carouselButton": "Carousel-module__XDPXaW__carouselButton",
  "carouselButtonsWrapper": "Carousel-module__XDPXaW__carouselButtonsWrapper",
  "carouselContent": "Carousel-module__XDPXaW__carouselContent",
  "carouselContentElement": "Carousel-module__XDPXaW__carouselContentElement",
  "carouselItem": "Carousel-module__XDPXaW__carouselItem",
  "carouselWrapper": "Carousel-module__XDPXaW__carouselWrapper",
  "embla-dot": "Carousel-module__XDPXaW__embla-dot",
  "emblaDot": "Carousel-module__XDPXaW__emblaDot",
  "emblaDotSelected": "Carousel-module__XDPXaW__emblaDotSelected",
  "emblaDots": "Carousel-module__XDPXaW__emblaDots",
});
